import { TimeUnit } from '@mews/enums';
import { createConditionSwitch } from '@mews/fp';
import { FrameworkTextKey as TextKey } from '../../FrameworkTextKey';

export interface MatchTimeUnitModifiers {
    plural?: boolean;
    perTimeUnit?: boolean;
    icuKeyEnabled?: boolean;
}

interface MatchProps extends MatchTimeUnitModifiers {
    timeUnit: TimeUnit | string;
    isServiceDayUse?: boolean;
    isSecondaryTimeUnit?: boolean;
    isHourlyService?: boolean;
}

export const matchTimeUnitKey = ({
    isServiceDayUse = false,
    timeUnit,
    plural = false,
    perTimeUnit = false,
    icuKeyEnabled = false,
    isSecondaryTimeUnit = false,
    isHourlyService = false,
}: MatchProps) =>
    createConditionSwitch([
        {
            cond: isHourlyService && perTimeUnit,
            value: TextKey.PerHour,
        },
        {
            cond: isServiceDayUse && plural,
            value: TextKey.DayPlural,
        },
        {
            cond: isServiceDayUse && perTimeUnit,
            value: TextKey.PerDay,
        },
        {
            cond: isServiceDayUse && icuKeyEnabled,
            value: TextKey.SelectedDays,
        },
        {
            cond: isServiceDayUse,
            value: TextKey.Day,
        },
        {
            cond: timeUnit === TimeUnit.Day && plural,
            value: TextKey.NightPlural,
        },
        {
            cond: timeUnit === TimeUnit.Day && perTimeUnit,
            value: TextKey.PerNight,
        },
        {
            cond: timeUnit === TimeUnit.Day && icuKeyEnabled,
            value: TextKey.SelectedNights,
        },
        {
            cond: timeUnit === TimeUnit.Day,
            value: TextKey.Night,
        },
        {
            cond: timeUnit === TimeUnit.Month && perTimeUnit,
            value: TextKey.PerMonth,
        },
        {
            cond: timeUnit === TimeUnit.Month && plural,
            value: TextKey.Months,
        },
        {
            cond: timeUnit === TimeUnit.Month && icuKeyEnabled,
            value: TextKey.SelectedMonths,
        },
        {
            cond: timeUnit === TimeUnit.Month && isSecondaryTimeUnit,
            value: TextKey.Days,
        },
        {
            cond: timeUnit === TimeUnit.Month,
            value: TextKey.Month,
        },
        {
            cond: timeUnit === TimeUnit.Hour && plural,
            value: TextKey.Hours,
        },
        {
            cond: timeUnit === TimeUnit.Hour && perTimeUnit,
            value: TextKey.PerHour,
        },
        {
            cond: timeUnit === TimeUnit.Hour && icuKeyEnabled,
            value: TextKey.SelectedHours,
        },
        {
            cond: timeUnit === TimeUnit.Hour,
            value: TextKey.Hour,
        },
    ]);
